export const SLICE_NAME:string = 'pages/toolbar';

export default interface IState {
  newDesignEnabled: boolean;
  filtersSidebarOpen: boolean;
  // 
  selectedPageIds: string[];
  loadingPageIds: string[];
};
